import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import * as CryptoJS from 'crypto-js';
import * as forge from 'node-forge';

@Injectable({
  providedIn: 'root'
})
export class SecureStorageService {

  key: string = environment.encryptionSecret;

  constructor(){}

  public saveData(key: string, value: string) {
    sessionStorage.setItem(key, this.encrypt(value));
  }

  public getData(key: string) {
    let data: string = sessionStorage.getItem(key) ?? "";
    const result = this.decrypt(data)

    return result;
  }
  public removeData(key: string) {
    sessionStorage.removeItem(key);
  }

  public clearData() {
    sessionStorage.clear();
  }

  public encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(txt, CryptoJS.enc.Utf8.parse(this.key) , {mode:CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7}).toString();
  }

  public encriptBase64(txt: string): string{
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(txt));
  }

  public decrypt(txtToDecrypt: string) {
    try {
      // INTENTO 1: Lógica v9 (AES-GCM) usando node-forge
      return this.decryptV9_GCM(txtToDecrypt);
    } catch (error) {
      //console.warn("Comuniquese con el administrador del sitio");
      
      try {
        // INTENTO 2: Fallback a v6 (AES-ECB) usando CryptoJS (Legacy)
        return this.decryptV6_ECB(txtToDecrypt);
      } catch (fatalError) {
        //console.error("Comuniquese con el administrador del sitio");
        return "";
      }
    }
  }

  public decryptBase64(txtToDecrypt: string): string{
    const decodedBase64 = CryptoJS.enc.Base64.parse(txtToDecrypt).toString(CryptoJS.enc.Utf8);
    return decodedBase64;
  }

  private decryptV6_ECB(txtToDecrypt: string): string {
    const decrypted = CryptoJS.AES.decrypt(
      txtToDecrypt, 
      CryptoJS.enc.Utf8.parse(this.key), 
      {
        mode: CryptoJS.mode.ECB, 
        padding: CryptoJS.pad.Pkcs7
      }
    );
    
    // Convertir a string UTF8. Si falla el padding aquí, devolverá cadena vacía y el JSON.parse fallará arriba.
    const result = decrypted.toString(CryptoJS.enc.Utf8);
    //if (!result) throw new Error("ECB decrypt devolvió vacío");
    return result;
  }

  private decryptV9_GCM(base64Str: string): string {
    // 1. Decodificar Base64 a bytes crudos
    const encryptedBytes = forge.util.decode64(base64Str);

    // 2. Validar longitud mínima (Nonce 16 + Tag 16 = 32 bytes mínimo)
    if (encryptedBytes.length < 32) {
      throw new Error("Data insuficiente para GCM");
    }

    // 3. Extraer partes según tu estructura Python: Nonce + Tag + Ciphertext
    // Python: combined = nonce + tag + ciphertext
    const nonce = encryptedBytes.substring(0, 16);
    const tag = encryptedBytes.substring(16, 32);
    const ciphertext = encryptedBytes.substring(32);

    // 4. Preparar el buffer de Forge
    const cipher = forge.cipher.createDecipher('AES-GCM', this.key);
    cipher.start({
      iv: nonce,
      tagLength: 128, // 128 bits = 16 bytes
      tag: forge.util.createBuffer(tag)
    });

    cipher.update(forge.util.createBuffer(ciphertext));
    const pass = cipher.finish();

    // 5. Si el tag no coincide, cipher.finish() devuelve false o lanza error
    if (!pass) {
      throw new Error("Error de integridad GCM (Tag mismatch)");
    }

    return cipher.output.toString();
  }
}
